<template>
  <div class="animated fadeIn">
    <Row>
      <Input clearable size="small" search @on-search="onFilterClick" v-model="keywordFilter" placeholder="名称/联系电话/联系地址" style="width: 200px; margin-right: 3px;"></Input>
      <Button size="small" type="primary" style=" margin-right: 3px;" @click="onFilterClick">查询</Button>
    </Row>
    <Row>
      <Checkbox v-model="handleOrder">不显示已处理</Checkbox>
    </Row>
    <Row style="margin-top: 3px;">
      <div>
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
    <process-remind-modal v-model="processRemindModal" :initValue="processRemindId" @on-success="onModifySuccess"></process-remind-modal>
    <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                               @on-success="onModifySuccess"></vehicle-info-detail-modal>
  </div>
</template>

<script>

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

import ProcessRemindModal from '@/view/transport/components/process-remind-modal'
import VehicleInfoDetailModal from '@/view/transport/components/vehicle-info-detail-modal'

function calRegistrationTextColor (colorid) {
  if (colorid === 1) {
    return '#ffffff'
  } else if (colorid === 2) {
    return '#ffffff'
  } else if (colorid === 3) {
    return '#ffffff'
  } else if (colorid === 4) {
    return '#000000'
  } else {
    return '#000000'
  }
}
function calRegistrationColor (colorid) {
  if (colorid === 1) {
    return '#2b85e4'
  } else if (colorid === 2) {
    return '#ff9900'
  } else if (colorid === 3) {
    return '#1c2438'
  } else if (colorid === 4) {
    return '#f8f8f9'
  } else {
    return '#bbbec4'
  }
}

export default {
  name: 'reminds',
  components: {
    ProcessRemindModal,
    VehicleInfoDetailModal
  },
  data () {
    return {

      handleOrder: true,

      vehicleOwnerInfoFilter: null,

      allVehicleOwnerInfos: [],

      // 车辆信息详细信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,

      processRemindModal: false,
      processRemindId: null,

      processStateFilter: null,
      remindTypeFilter: null,

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,
      totalElements: 0,
      content: [],
      pageSize: 30,
      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '车牌',
          resizable: true,
          key: 'transportVehicleInfoId',
          ellipsis: 'true',
          width: 120,
          sortable: 'custom',
          render: function (h, params) {
            let registrationNum = params.row.transportVehicleInfo.registrationNum
            if (params.row.customName) {
              registrationNum = registrationNum + '(' + params.row.customName + ')'
            }
            return h('div', {
              props: {
                disabled: false
              },
              style: {
                'text-align': 'center',
                backgroundColor: calRegistrationColor(params.row.transportVehicleInfo.registrationColor),
                color: calRegistrationTextColor(params.row.transportVehicleInfo.registrationColor)
              },
              on: {
                click: () => {
                  // this.onRegistrationNOClick(params.row)
                }
              }
            }, registrationNum)
          }
        },
        {
          title: '车辆所有人',
          resizable: true,
          key: 'transportVehicleInfo.vehicleOwnerInfoId',
          sortable: 'custom',
          ellipsis: 'true',
          minWidth: 180,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.vehicleOwnerInfoFilter = []
              val.forEach(item => {
                this.vehicleOwnerInfoFilter.push(genQueryParam('transportVehicleInfo.vehicleOwnerInfoId', 'EQ', item))
              })
            } else {
              this.vehicleOwnerInfoFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            if (params.row.transportVehicleInfo.vehicleOwnerInfo) {
              return h('label', params.row.transportVehicleInfo.vehicleOwnerInfo.shortName)
            }
          }
        },
        {
          title: '客户',
          resizable: true,
          key: 'transportVehicleInfo.clientInfoId',
          sortable: 'custom',
          ellipsis: 'true',
          minWidth: 180,
          render: (h, params) => {
            let display = []
            if (params.row.transportVehicleInfo.clientInfo) {
              display.push(h('div', params.row.transportVehicleInfo.clientInfo.name + '(' + params.row.transportVehicleInfo.clientInfo.phoneNum + ')'))
            } else {
              display.push(h('div', '无'))
            }
            return h('div', display)
          }
        },
        {
          title: '提醒类型',
          resizable: true,
          key: 'remindType',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [
            { label: '年审提醒', value: 1 },
            // { label: '季审提醒', value: 2 },
            { label: '交强险提醒', value: 3 },
            { label: '商业险提醒', value: 4 },
            { label: '挂靠服务提醒', value: 5 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.remindTypeFilter = []
              val.forEach(item => {
                this.remindTypeFilter.push(genQueryParam('remindType', 'EQ', item))
              })
            } else {
              this.remindTypeFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            let state = params.row.remindType
            if (state === 1) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '年审提醒')
              ])
            } else if (state === 2) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '季审提醒')
              ])
            } else if (state === 3) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '交强险提醒')
              ])
            } else if (state === 4) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '商业险提醒')
              ])
            } else if (state === 5) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '挂靠服务提醒')
              ])
            }
          }
        },
        {
          title: '处理状态',
          resizable: true,
          key: 'processState',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [
            { label: '作废', value: 0 },
            { label: '正在跟进', value: 1 },
            { label: '已处理', value: 2 },
            { label: '未处理', value: 3 },
            { label: '剩下10天', value: 4 },
            { label: '剩下5天', value: 5 },
            { label: '已过期', value: 6 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.processStateFilter = []
              val.forEach(item => {
                this.processStateFilter.push(genQueryParam('processState', 'EQ', item))
              })
            } else {
              this.processStateFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            let state = params.row.processState
            if (state === 0) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'red'
                  }
                }, '作废')
              ])
            } else if (state === 1) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '正在跟进')
              ])
            } else if (state === 2) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '已处理')
              ])
            } else if (state === 3) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '未处理')
              ])
            } else if (state === 4) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '剩下10天')
              ])
            } else if (state === 5) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '剩下5天')
              ])
            } else if (state === 6) {
              return h('div', [
                h('Tag', {
                  props: {
                    color: 'blue'
                  }
                }, '已过期')
              ])
            }
          }
        },
        {
          title: '备注',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'processRemark',
          width: 160
        },
        {
          title: '到期时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'oldDatetime',
          width: 160,
          render: function (h, params) {
            if (params.row.oldDatetime) {
              let d = new Date(params.row.oldDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '更新时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'updateDatetime',
          width: 160,
          render: function (h, params) {
            if (params.row.updateDatetime) {
              let d = new Date(params.row.updateDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '分析时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'analyzeDatetime',
          width: 160,
          render: function (h, params) {
            if (params.row.analyzeDatetime) {
              let d = new Date(params.row.analyzeDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          width: 180,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehicleInfoDetailId = params.row.transportVehicleInfoId
                    this.vehicleInfoDetailModal = true
                  }
                }
              }, '车辆信息'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.processRemindId = params.row.id
                    this.processRemindModal = true
                  }
                }
              }, '处理'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '提示',
                      content: '<p>确认作废</p>',
                      onOk: () => {
                        store.dispatch('RemindServ_Cancel', {
                          params: { id: params.row.id }
                        }).then(() => {
                          this.$Message.success('作废成功')
                          this.onModifySuccess()
                        }).catch(err => {
                          this.$Message.error(err)
                        })
                      },
                      onCancel: () => {

                      }
                    })
                  }
                }
              }, '作废')
            ])
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'TransportVehicleInfoServ_GetPage'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage()
    },
    onColumnUpdate () {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '跟进业务员') {
          this.columns[i].filters = this.marketsales
          break
        }
        if (this.columns[i].title === '车辆所有人') {
          this.columns[i].filters = this.allVehicleOwnerInfos
          break
        }
      }
    },
    onFilterClick () {
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let qo5 = null
      let qo6 = null
      let qo7 = null

      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('updateDatetime', false)
      }

      if (this.handleOrder) {
        queryParams.push(genQueryParam('processState', 'NEQ', 0))
        queryParams.push(genQueryParam('processState', 'NEQ', 2))
      }

      if (this.processStateFilter) {
        qo5 = this.processStateFilter
      }

      if (this.remindTypeFilter) {
        qo6 = this.remindTypeFilter
      }

      if (this.vehicleOwnerInfoFilter) {
        qo7 = this.vehicleOwnerInfoFilter
      }

      store.dispatch('RemindServ_ClientGetPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo5: qo5,
          qo6: qo6,
          qo7: qo7,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        if (store.getters.get_Remind_ClientGetPageResult) {
          this.totalElements = store.getters.get_Remind_ClientGetPageResult.totalElements
          this.content = store.getters.get_Remind_ClientGetPageResult.content
          this.pageSize = store.getters.get_Remind_ClientGetPageResult.size
        } else {
          this.totalElements = 0
          this.content = []
          this.pageSize = 0
        }
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage () {
      this.setPage(this.pageIndex)
    }
  },
  mounted () {
    this.$nextTick(() => {
      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [7] }
      }).then(() => {
        let marketsales = store.getters.get_User_GetAllUsersResult
        this.marketsales = marketsales.map(item => {
          return { label: item.realName, value: item.id }
        })
        // this.columns[4].filters = this.installers
        // this.columns[13].filters = this.marketsales
        store.dispatch('VehicleOwnerInfoServ_ClientGetPage', {
          params: null,
          urlparams: null
        }).then(() => {
          let allVehicleOwnerInfos = store.getters.get_VehicleOwnerInfo_ClientGetPageResult.content
          this.allVehicleOwnerInfos = []
          allVehicleOwnerInfos.forEach(item => {
            this.allVehicleOwnerInfos.push({ label: item.shortName, value: item.id })
          })
          this.onColumnUpdate()
        }).catch(err => {
          this.$Message.error(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })

      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
